import { render } from "./FormBuilder.vue?vue&type=template&id=14df23e8&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"

import "./FormBuilder.vue?vue&type=style&index=0&id=14df23e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14df23e8"]])

export default __exports__